
import React, {Fragment,useState, useEffect} from 'react'
import axios from 'axios';
import { useHistory } from "react-router-dom";

export const Listadopatrocinadoresinterior = (props) => {
   
    
    return  (
        <Fragment>
            <div className="listadoPatrocinadores">
               
                            <div className={`gruposponsor ${props.titulo}`}>
                                <div className="titulospaonsor">{props.titulo}</div>
                                <div className="contenedoritemsponsor">
                                {
                                    props.items.map(item =>
                                        <Fragment>
                                                <div className="itemsponsor">
                                                    {item.enlace !== null ? 
                                                        <><a href={item.enlace} target={item.targer !== null ? item.target: ''}><img src={item.urlLogotipo} /></a></>
                                                    :
                                                        <img src={item.urlLogotipo} />
                                                    }
                                                    
                                                </div>
                                    
                                        </Fragment>
                                    )
                                }
                                    
                                </div>
                            </div> 
                      
                       
            </div>
        </Fragment> 
    )
    
}
